import "./LPContent.scss";
import "./LPContentMobile.scss";
import LoginForm from "./LPLoginForm";
import LoginLogo from "../../Assets/Logo/LoginPageLogo.png";
import { Link } from "react-router-dom";
import trioClouds from "../../Assets/Design/dontHaveAccountYet2.png";

import getstarted from "../../Assets/Design/GetStartedHere.png";
function LPContent() {
  return (
    <div className="lp-header-container">
      <div className="lp-header-logo-wrapper">
        <Link to="/">
          <img src={LoginLogo} />
        </Link>
      </div>
      <div className="lp-header-login-header">LOG IN NOW!</div>

      <div className="lp-header-signup-message">
        <img src={trioClouds} className="lp-trioClouds" />
        <Link to="/Sign-up" className="lp-signup-link">
          <img src={getstarted} className="lp-getstarted" />
        </Link>
      </div>
      <LoginForm />
    </div>
  );
}

export default LPContent;
